module.exports = __webpack_public_path__ + "routes/urzad/szczegolyUrzedu/logo_inspire.png?bd7c043b";


//////////////////
// WEBPACK FOOTER
// ./routes/urzad/szczegolyUrzedu/logo_inspire.png
// module id = 1839
// module chunks = 0